module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/crop-7b6b6d0a18aa62717c38184a44f5b09a.svg";